import * as React from "react";
const SvgFiRrHexagon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hexagon_svg__a)">
      <path
        fill="#062147"
        d="M0 12c0-.81.2-1.62.59-2.36l3.22-6A4.99 4.99 0 0 1 8.22 1h7.58c1.85 0 3.54 1.01 4.41 2.64l3.2 6c.79 1.48.79 3.24 0 4.71l-3.2 6a4.99 4.99 0 0 1-4.41 2.64H8.22c-1.85 0-3.53-1.01-4.41-2.64L.59 14.37C.2 13.63 0 12.82 0 12m22 0c0-.49-.12-.97-.35-1.41l-3.2-6A3 3 0 0 0 15.8 3H8.22c-1.11 0-2.12.61-2.64 1.58l-3.22 6c-.47.89-.48 1.95 0 2.84l3.22 6C6.1 20.4 7.12 21 8.22 21h7.58c1.11 0 2.12-.61 2.65-1.59l3.2-6c.24-.44.35-.93.35-1.41"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hexagon_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHexagon;
